import { useState } from 'react'

import { HighlightContext, KeyType } from './useHighlightContext'

export default function HighlightContextProvider({ children }) {
  const [hlKey, setHlKey] = useState<KeyType>(null)
  const [isMatch, setIsMatch] = useState<boolean>(true)

  return (
    <HighlightContext.Provider
      value={{
        hlKey,
        isMatch,
        update: (hlKey: KeyType, isMatch = true) => {
          setHlKey(hlKey)
          setIsMatch(isMatch)
        },
      }}
    >
      {children}
    </HighlightContext.Provider>
  )
}
